/* import __COLOCATED_TEMPLATE__ from './feature-gate.hbs.js'; */
import FeatureGateBase from './feature-gate-base';
export default class FeatureGate extends FeatureGateBase {
  get showContent() {
    if (this.isLoading) {
      return false;
    }
    if (this.isError) {
      return this.args.fallbackFeatureEntitlement;
    }
    return this.isEntitledToFeature;
  }
}